"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _xDataGridPro = require("@mui/x-data-grid-pro");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

_xDataGridPro.LicenseInfo.setLicenseKey('57b44ce0accc216f657250faa7a244dfT1JERVI6Mzg3MzcsRVhQSVJZPTE2Nzc2Nzc0ODEwMDAsS0VZVkVSU0lPTj0x');

var DataGridPro = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var rest = _extends({}, _ref);

  return /*#__PURE__*/_react.default.createElement(_xDataGridPro.DataGridPro, _extends({
    ref: ref
  }, rest));
});

var _default = DataGridPro;
exports.default = _default;